import { Configure, InstantSearch } from "react-instantsearch";
import React, { useMemo } from "react";
import { applyPageFilters, getSearchAnalyticsTags } from "./filters";
import { useRouting } from "./routing";
import { SearchPageProps } from "../../components/pages/SearchPage/SearchPage";
import { hitsPerPage, useSearchClient } from "./searchClient";
import { pageIndexName } from "./sorting";
import { ConfigureProps } from "react-instantsearch-core/dist/es/components/Configure";

type Props = {
  searchPageProps?: SearchPageProps;
  children: React.ReactNode;
};

export default function SearchProvider({ searchPageProps = {}, children }: Props) {
  const { searchProps } = searchPageProps;
  const { categories } = searchProps;
  const indexName = pageIndexName(searchPageProps);
  const routing = useRouting(categories, indexName);
  const filters = applyPageFilters(searchPageProps);
  const remoteIp = searchPageProps?.remoteIp;
  const searchClient = useSearchClient(remoteIp);

  const providerConfig = useMemo(
    () => ({
      searchClient,
      indexName,
      routing,
      insights: true,
      future: {
        preserveSharedStateOnUnmount: true,
        persistHierarchicalRootCount: true,
      },
    }),
    [indexName, routing, remoteIp]
  );

  const searchConfig = useMemo(
    () =>
      ({
        hitsPerPage,
        filters,
        attributesToHighlight: [],
        clickAnalytics: true,
        analytics: true,
        analyticsTags: getSearchAnalyticsTags(searchPageProps),
      } as ConfigureProps),
    [searchPageProps, filters]
  );

  return (
    // @ts-ignore
    <InstantSearch {...providerConfig}>
      <Configure {...searchConfig} />
      {children}
    </InstantSearch>
  );
}
